import { render, staticRenderFns } from "./PosClientMonitorConfigPopup.vue?vue&type=template&id=7b0bc1a2&scoped=true&"
import script from "./PosClientMonitorConfigPopup.vue?vue&type=script&lang=js&"
export * from "./PosClientMonitorConfigPopup.vue?vue&type=script&lang=js&"
import style0 from "./PosClientMonitorConfigPopup.vue?vue&type=style&index=0&id=7b0bc1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0bc1a2",
  null
  
)

export default component.exports